import { createAsyncThunk } from '@reduxjs/toolkit';

import { authGet } from '../../utils/request';

const getCountriesStateList = createAsyncThunk(
  'general/getCountriesStateList',
  async (code, { rejectWithValue }) => {
    try {
      const { data } = await authGet(`/general/list/countries/${code}`);
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export default getCountriesStateList;
